/**
 * Account-settings data layer — typed wrappers over api() for the per-user
 * API-key (MCP) and encrypted-secret endpoints under /api/account.
 */
import { api } from './api';

export interface AccountApiKey {
  id: string;
  name: string;
  prefix: string;
  createdAt: string;
  lastUsedAt: string | null;
  revokedAt: string | null;
}

export interface AccountSecret {
  key: string;
  value: string;
  createdAt: string;
  updatedAt: string;
}

export interface CreatedApiKey extends AccountApiKey {
  /** Full plaintext — returned exactly once at create time. */
  key: string;
}

export async function listApiKeys(): Promise<AccountApiKey[]> {
  const r = await api<{ keys: AccountApiKey[] }>('/api/account/api-keys');
  return r.keys ?? [];
}

export async function createApiKey(name: string): Promise<CreatedApiKey> {
  return api<CreatedApiKey>('/api/account/api-keys', {
    method: 'POST',
    body: JSON.stringify({ name }),
  });
}

export async function revokeApiKey(id: string): Promise<void> {
  await api(`/api/account/api-keys/${encodeURIComponent(id)}`, { method: 'DELETE' });
}

export async function listSecrets(): Promise<AccountSecret[]> {
  const r = await api<{ secrets: AccountSecret[] }>('/api/account/secrets');
  return r.secrets ?? [];
}

export async function putSecret(key: string, value: string): Promise<{ key: string; updatedAt: string }> {
  return api(`/api/account/secrets/${encodeURIComponent(key)}`, {
    method: 'PUT',
    body: JSON.stringify({ value }),
  });
}

export async function deleteSecret(key: string): Promise<void> {
  await api(`/api/account/secrets/${encodeURIComponent(key)}`, { method: 'DELETE' });
}
